import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import {
  SubscribeBell,
  ActiveSubscribeBell,
} from '@lt/components/icons-react/floating-panel';

import {
  FloatingPanelButton,
  ButtonContainer,
  BottomButtonText,
} from '../styles';
import {
  ACTIVE_SUBSCRIBE_BELL_DATA_TEST_ID,
  SUBSCRIBE_BELL_DATA_TEST_ID,
  SUBSCRIBE_BUTTON_DATA_TEST_ID,
} from './constants';

interface ISubscribeButton {
  isSubscribed: boolean;
  toggleSubscribe: () => void;
}

const SubscribeButton = ({
  isSubscribed,
  toggleSubscribe,
}: ISubscribeButton) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      onClick={toggleSubscribe}
      data-testid={SUBSCRIBE_BUTTON_DATA_TEST_ID}
    >
      <ButtonContainer>
        {isSubscribed ? (
          <StyledActiveSubscribeBell
            data-testid={ACTIVE_SUBSCRIBE_BELL_DATA_TEST_ID}
          />
        ) : (
          <StyledSubscribeBell data-testid={SUBSCRIBE_BELL_DATA_TEST_ID} />
        )}
        <BottomButtonText>{t('subscribe.button')}</BottomButtonText>
      </ButtonContainer>
    </Button>
  );
};

const Button = styled(FloatingPanelButton)`
  border-top-left-radius: 28px;
  border-bottom-left-radius: 28px;
  padding-left: 6px;
`;

const StyledSubscribeBell = styled(SubscribeBell)`
  width: 24px;
  height: 24px;
`;

const StyledActiveSubscribeBell = styled(ActiveSubscribeBell)`
  width: 24px;
  height: 24px;
`;

export default SubscribeButton;
